import React, { useState, useEffect } from "react";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";

function Contact() {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isButtonClicked, setButtonClicked] = useState(false);
  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false); // State variable for country dropdown visibility
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false); // State variable for state dropdown visibility
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false); // State variable for state dropdown visibility
  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
    who_are_you: "",
    message: "",
    country: "",
    state: "",
    city: "",
  });
  
  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setSelectedState("");
    setSelectedCity("");
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setSelectedCity("");
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };

  const toggleCountryDropdown = () => {
    setCountryDropdownOpen(!countryDropdownOpen);
  };

  const toggleStateDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(!stateDropdownOpen);
    console.log(!stateDropdownOpen, "stateDropdownOpen");
  };

  const toggleCityDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(false);
    setCityDropdownOpen(!cityDropdownOpen);
    console.log(!cityDropdownOpen, "cityDropdownOpen");
  };

  const toggleCityCloseDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(false);
    setCityDropdownOpen(false);
  };

  // Fetch the list of countries
  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  // Fetch the list of states based on the selected country
  const stateOptions = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  // Fetch the list of cities based on the selected state
  const cityOptions = selectedState
    ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
        (city) => ({
          label: city.name,
          value: city.name,
        })
      )
    : [];

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Mobile is required"),
    who_are_you: Yup.string().required("Please select a Your profession"),
    message: Yup.string().required("Message is required"),
  });

  const dataSubmit = async (values) => {
    try {
      // Add the selected country, state, and city to the values object
      values.country = selectedCountry ? selectedCountry.label : "";
      values.state = selectedState ? selectedState.label : "";
      values.city = selectedCity ? selectedCity.label : "";

      const response = await axios.post(
        "https://mahalaxmioil.3waysource.com/api.php",
        values
      );
      console.log(response.data); // Handle the API response as needed
      // Display SweetAlert on success
      setInitialValues({
        name: "",
        email: "",
        phone: "",
        who_are_you: "",
        message: "",
        country: "",
        state: "",
        city: "",
      });

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Your data submitted successfully",
        showConfirmButton: false,
        timer: 2500,
      });

      // Close the modal
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="page-content">
        {/* Banner Area */}
        <div className="aon-page-benner-area2">
          <div className="aon-page-banner-row2">
            <div className="aon-page-benner-overlay2" />
            <div className="sf-banner-heading-wrap2">
              <div className="sf-banner-heading-area2">
                <div className="sf-banner-breadcrumbs-nav2">
                  <ul className="list-inline">
                    <li>
                      <a href="/"> Home </a>
                    </li>
                    <li>Contact Us</li>
                  </ul>
                </div>
                <div className="sf-banner-heading-large2">Contact Us</div>
              </div>
              {/* <div className="sf-banner-vid-section">
                <div className="video-play-btn2">
                  <a
                    className="mfp-video"
                    href="https://www.youtube.com/watch?v=c1XNqw2gSbU"
                  >
                    <i className="fa fa-play" />
                  </a>
                  <span>
                    Watch Now <br />
                    Companey Details
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {/* Banner Area End */}
        {/* Left & right section */}
        <div className="aon-farm-faq-area">
          <div className="site-top-line" />
          <div className="container">
            <div className="aon-con-map ">
              {/*Google Map*/}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d33918.63710294555!2d73.19675134904286!3d23.325433402969896!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395de40ed174a02f%3A0x6e5a1949499b6f4b!2sMAHALAXMI%20OIL%20MILL!5e0!3m2!1sen!2sin!4v1689167220035!5m2!1sen!2sin"
                width="600"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              {/*Contact Info*/}
              <div className="aon-con-info-box">
                <h3 className="aon-con-info-title">Contact 24/7</h3>
                <p className="aon-con-info-text">
                  Plot No. 20, Shopping, Letar - Kapadwanj Rd, Ayodhya Nagar,
                  Dhansura, Gujarat 383310
                </p>
                <ul className="aon-con-info-list">
                  {/*Phone*/}
                  <li className="d-flex">
                    <div className="aon-con-icon">
                      <i className="flaticon-telephone" />
                    </div>
                    <div className="aon-con-text">
                      <span>Contact Phone</span>
                      <strong>+91 07575094646</strong>
                    </div>
                  </li>
                  {/*Email*/}
                  <li className="d-flex">
                    <div className="aon-con-icon">
                      <i className="flaticon-mail-1" />
                    </div>
                    <div className="aon-con-text">
                      <span>Contact Mail</span>
                      <strong>info@mahalaxmioilmill.com</strong>
                    </div>
                  </li>
                  {/*Address*/}
                  <li className="d-flex">
                    <div className="aon-con-icon">
                      <i className="flaticon-location-pin-1" />
                    </div>
                    <div className="aon-con-text">
                      <span>Contact Location</span>
                      <strong>
                        Plot No. 20, Shopping, Letar - Kapadwanj Rd, Ayodhya
                        Nagar, Dhansura, Gujarat 383310
                      </strong>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="aon-contact-wrap">
              <div className="sf-con-form-title text-center">
                <span className="aon-sub-title">Contact Us</span>
                <h2 className="m-b30">Contact Information</h2>
              </div>
              {/*Contact Information*/}
              <Formik
                initialValues={{ initialValues }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  dataSubmit(values);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="row">
                      {/* <fieldset> */}
                      {/* COLUMNS 1 */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            id="name"
                            placeholder="Name *"
                            type="text"
                            className={
                              touched.name && errors.name ? "error" : ""
                            }
                          />
                          {touched.name && errors.name && (
                            <p className="error-message">{errors.name}</p>
                          )}
                        </div>
                      </div>
                      {/* COLUMNS 2 */}

                      {/* COLUMNS 3 */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            id="phone"
                            placeholder="Mobile *"
                            type="tel"
                            className={
                              touched.phone && errors.phone ? "error" : ""
                            }
                          />
                          {touched.phone && errors.phone && (
                            <p className="error-message">{errors.phone}</p>
                          )}
                        </div>
                      </div>
                      {/* COLUMNS 4 */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            id="email"
                            placeholder="Email *"
                            type="email"
                            className={
                              touched.email && errors.email ? "error" : ""
                            }
                          />
                          {touched.email && errors.email && (
                            <p className="error-message">{errors.email}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <select
                            name="who_are_you"
                            id="who_are_you"
                            value={values.who_are_you}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={
                              touched.who_are_you && errors.who_are_you
                                ? "error"
                                : ""
                            }
                          >
                            <option value="">Who You Are</option>
                            <option value="Farmer">Farmer</option>
                            <option value="Trader">Trader</option>
                            <option value="Wholeseller">Wholeseller</option>
                            <option value="Other">Other</option>
                          </select>
                          {touched.who_are_you && errors.who_are_you && (
                            <p className="error-message">
                              {errors.who_are_you}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Country</label>

                          <Select
                            options={countryOptions}
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            onMenuOpen={toggleCountryDropdown}
                            onMenuClose={toggleCountryDropdown}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>State</label>
                          <Select
                            options={stateOptions}
                            value={selectedState}
                            onChange={handleStateChange}
                            isDisabled={!selectedCountry}
                            onMenuOpen={toggleStateDropdown}
                            onMenuClose={toggleStateDropdown}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>City</label>
                          <Select
                            options={cityOptions}
                            value={selectedCity}
                            onChange={handleCityChange}
                            isDisabled={!selectedState}
                            onMenuOpen={toggleCityDropdown}
                            onMenuClose={toggleCityCloseDropdown}
                          />
                        </div>
                      </div>
                      {/* COLUMNS 5 */}
                      <div className="col-md-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            id="message"
                            value={values.message}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Message *"
                            type="text"
                            className={
                              touched.message && errors.message ? "error" : ""
                            }
                          />
                          {touched.message && errors.message && (
                            <p className="error-message">{errors.message}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="aon-con-us-text text-center">
                          * Call us 24/7 at +917575094646 or fill out the form
                          below to receive a free and confidential initial
                          consultation.
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div
                          className="g-recaptcha"
                          data-sitekey="6LfcCr0eAAAAAN2P-3cJJC1StgxbUWvwELbMVjnp"
                        />
                      </div>
                      {/* </fieldset> */}
                    </div>
                    <div className="sf-contact-submit-btn text-center">
                      <button
                        className="site-button-secondry btn-animate-one"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Submit Now
                        <i className="btn-arrow-icon fa fa-angle-right" />
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
              {/*Contact Information End*/}
            </div>
          </div>
          <div className="site-bot-line" />
        </div>
        {/* Left & right section  END */}
      </div>
    </>
  );
}

export default Contact;
